import React from "react";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";
import { useQuery } from "@tanstack/react-query";
import { type DropdownProps } from "../models";
import Status from "components/Status/Status";

interface Props extends DropdownProps<server.dto.StatusSmall> {
  mainArea: server.dto.MainAreas;
  clientId: number;
}

const StatusDropdown = (props: Props) => {
  const previousMainArea = React.useRef(props.mainArea);
  const query = useQuery({
    queryFn: async () => window.CoreApi.Status.ListSmall({ clientId: props.clientId, mainArea: props.mainArea }).then(r => r.data.data),
    queryKey: ["statuses", props.mainArea, props.clientId],
    enabled: !props.options,
    initialData: props.options ?? [],
    onSuccess: (res) => {
      if (previousMainArea.current !== props.mainArea) {
        props.onChange(res[0]);
        previousMainArea.current = props.mainArea;
      }
    }
  });

  return <BaseReactSelectDropdown
    excludeKeys={props.excludeKeys}
    options={query.data}
    getLabel={status => status.title}
    getValue={status => status.statusId}
    value={props.value}
    onChange={props.onChange}
    onEsc={props.onEsc}
    config={{
      isSearchable: false,
      ...props.config
    }}
    renderOption={(status) => <Status status={status} />}
    renderSelectedValue={(status) => <Status status={status} />}
  />;
};

export default StatusDropdown;